import { Divider } from '@sixui/ui';

import { commonStyles } from '~/styles/commonStyles';

export type ITableRowProps = {
  children?: React.ReactNode;
  first?: boolean;
};

export const TableRow: React.FC<ITableRowProps> = ({ children, first }) => (
  <>
    {first ? null : <Divider sx={commonStyles.colSpanFull} />}
    {children}
  </>
);
